import { Component, OnInit } from '@angular/core';
import { AutoLogoutService } from '../../shared/services/auto-logout.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-auto-logout',
  templateUrl: './auto-logout.component.html',
  styleUrls: ['./auto-logout.component.scss'],
  providers: [AutoLogoutService]
})
export class AutoLogoutComponent implements OnInit {

  constructor(private autoLogoutService: AutoLogoutService,private router: Router) { }
 
  ngOnInit() {
    localStorage.setItem('lastAction', Date.now().toString());
  
    window.addEventListener('storage', (event) => {
      if (event.storageArea == localStorage) {
        let token = localStorage.getItem('access_token');
        if(token == undefined) { 
            this.router.navigate(['/']);
        }
      }
    }, false);
  }
   
}



// WEBPACK FOOTER //
// /codebuild/output/src1639192363/src/src/app/common/auto-logout/auto-logout.component.ts